/* eslint-disable @typescript-eslint/naming-convention */
import React from "react";
import { PrismicRichText } from "@prismicio/react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Container, Row, Col } from "react-bootstrap";
import Anchor from "../elements/Anchor";

import "../../styles/components/slices/online_app.scss";

const OnlineApp = ({ slice }) => {
  if (!slice) return null;
  const { items, primary, slice_type } = slice;

  return (
    <Container
      fluid
      className={slice_type}
      style={{
        backgroundImage: primary?.background_image
          ? `url(${primary?.background_image?.gatsbyImageData?.images?.fallback?.src})`
          : "none",
        backgroundColor: primary?.background_image
          ? "#F6F8FC"
          : primary?.background_color,
        backgroundSize: "cover",
      }}
    >
      <Container className="max-container">
        <Row className="justify-content-center">
          <Col sm={12} md={7} className="order-2 order-md-1">
            <div className="title mb-4">
              <h2>{primary?.title?.text}</h2>
            </div>
            <p className="mb-5 mona">{primary?.subtitle}</p>
            <div className="list">
              <PrismicRichText field={primary?.list?.richText} />
            </div>
            <div className="me-auto mt-5 d-none d-md-flex">
              {items?.map((btn, index) => {
                return (
                  <div
                    className="online-app align-content-center me-2"
                    key={index}
                  >
                    <Anchor
                      key={index}
                      href={btn?.button_link?.url}
                      className="text-center"
                      target="_blank"
                    >
                      {btn?.icon && (
                        <GatsbyImage
                          image={btn.icon?.gatsbyImageData}
                          alt={btn?.icon?.alt || "app image"}
                          className="me-2"
                        />
                      )}
                      {btn?.button_label}
                    </Anchor>
                  </div>
                );
              })}
            </div>
            <div className="me-auto my-5 d-flex flex-column d-md-none">
              {items?.map((btn, index) => {
                return (
                  <div
                    className="online-app align-content-center mb-2 mx-auto"
                    key={index}
                  >
                    <Anchor
                      key={index}
                      href={btn?.button_link?.url}
                      className="text-center fz-2"
                      target="_blank"
                    >
                      {btn?.icon && (
                        <GatsbyImage
                          image={btn.icon?.gatsbyImageData}
                          alt={btn?.icon?.alt || "app image"}
                          className="me-2"
                        />
                      )}
                      {btn?.button_label}
                    </Anchor>
                  </div>
                );
              })}
            </div>
          </Col>
          <Col sm={12} md={5} className="align-self-center order-1 order-md-2">
            <GatsbyImage
              image={primary?.image?.gatsbyImageData}
              alt={primary?.image?.alt || "app image"}
              className={primary?.border_radius ? "border-radius" : ""}
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default OnlineApp;
